import React from 'react';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import properties from '../../constants/Properties';
import populateMediaFilesUtils from '../utils/PopulateMediaFilesUtils';
import configuration from '../../constants/Configuration';
import { setMediaFilesDataProvider } from '../../actions/AccordionActions';
import { MediaSoundsList } from '../menus/MediaSoundsList';
import locales from '../../locales/LocalesManager';
import apiServiceUtils from '../../components/utils/ApiServiceUtils';
import mouseUtils from '../../components/utils/MouseUtils';
import { changeSlideAudioIndex } from '../../actions/MusicActions';
import { AudioCategorySelectorNew } from '../../components/menus/AudioCategorySelectorNew';
import hoverManager from '../utils/HoverManager';
import platformDetection from '../utils/PlatformDetection';
import {expandAudioList} from '../../actions/MenuActions';

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn() {
        this.setState({
            isOver: true
        });
    },
    onMouseOut() {
        this.setState({
            isOver: false
        });
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        switch (this.props.index) {
            case 0: {
                this.props.dispatch(changeSlideAudioIndex(0));
                break;
            }

            case 1: {
                this.props.dispatch(changeSlideAudioIndex(1));
                break;
            }
        }

        this.props.dispatch(expandAudioList(false, this.props.type));
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.props.category != newProps.category || this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        var iconColor;
        var buttonColor;
        var effectsSelected = false;

        if (this.props.category == 0)
            effectsSelected = true;

        if (this.props.index == 0) { // Effects button
            if (effectsSelected == true) {
                iconColor = 'white';
                buttonColor = properties.BROWSER_SELECTED_COLOR;
            } else {
                if (this.state.isOver == true) {
                    iconColor = properties.CONTEXT_HOVER_COLOR;
                    buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
                } else {
                    iconColor = 'black';
                    buttonColor = '#D7D7D7';
                }
            }

        } else { // My sounds button
            if (effectsSelected == false) {
                iconColor = 'white';
                buttonColor = properties.BROWSER_SELECTED_COLOR;
            } else {
                if (this.state.isOver == true) {
                    iconColor = properties.CONTEXT_HOVER_COLOR;
                    buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
                } else {
                    iconColor = 'black';
                    buttonColor = '#D7D7D7';
                }
            }
        }

        var topPosition = 0;
        var left = this.props.index == 0 ? 0 : this.props.accordionWidth / 2;

        var buttonStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: this.props.accordionWidth / 2 - 2,
            height: properties.BROWSER_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            left: left,
            top: topPosition,
            color: 'white',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#FFFFFF',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        var spanStyle = {
            color: iconColor,
            cursor: 'default',
            width: buttonStyle.width - 2 * 5,
            fontSize: 15,
            position: 'absolute',
            left: 5,
            top: 6,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textAlign: 'center'
        };

        var text = this.props.text;

        if (this.props.index == 0) {
            text = locales.getCaption('SoundEffects', 'music');
        } else {
            text = locales.getCaption('MySoundsContent', 'music');
        }

        return (
            <button aria-label={text} style={buttonStyle} onClick={this.onClick} onTouchStart={this.onClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                <span style={spanStyle}>{text}</span>
            </button>
        );
    }
});

const SlideSoundsBrowserContent = React.createClass({
    componentDidMount() {
        const dataProvider = this.props.mediaFilesDataProvider;

        if (dataProvider != undefined) {
            return;
        }

        if (configuration.LOAD_LOCAL == true) {
            // FOR TEST
            this.props.dispatch(setMediaFilesDataProvider({imagesDataProvider: populateMediaFilesUtils.getImagesDataProviderForTest(), soundsDataProvider: populateMediaFilesUtils.getSoundsDataProviderForTest()}));
        } else {
            apiServiceUtils.executeSafeApiCall(this.loadMyMediaFiles.bind(this));
        }
    },
    loadMyMediaFiles() {
        apiServiceUtils.executeGetMediaFilesCall(this.parseMediaItems.bind(this));
    },
    parseMediaItems(items) {
        populateMediaFilesUtils.parseMediaItems(items, this.props.dispatch, true);
    },
    getDataProvider() {
        if (this.props.slideAudioIndex == 0) { // effects
            const soundClipartModel = this.props.soundClipartModel;

            if (soundClipartModel) {
                var newDataProvider = [];

                if (soundClipartModel && soundClipartModel.items[1]) {
                    let soundEffects = soundClipartModel.items[1];
                    newDataProvider = soundEffects.items[this.props.soundEffectsCategoryIndex].items;
                }

                return newDataProvider;
            } else
                return [];
        } else { // my sounds
            const dataProvider = this.props.mediaFilesDataProvider;

            if (dataProvider != undefined) {
                return this.filterMySounds(dataProvider.soundsDataProvider);
            } else
                return undefined;
        }
    },
    filterMySounds(dataProvider) {
        var category = this.getSelectedIndex('second');
        var i;
        var array = [];

        for (i=0; i<dataProvider.length; i++) {
            if (category == 1) {// recorded sounds
                if (dataProvider[i].isRecordedSound)
                    array.push(dataProvider[i]);
            } else {
                if (!dataProvider[i].isRecordedSound)
                    array.push(dataProvider[i]);
            }
        }

        return array;
    },
    getSelectedIndex() {
        var index = this.props.soundEffectsCategoryIndex;

        if (index == undefined || isNaN(index))
            index = 0;

        return index;
    },
    isCategorySelectorVisible() {
        if (this.props.slideAudioIndex == 0)
            return true;
        else
            return false;
    },
    getMySoundsCategories() {
        var dataProvider = [];

        dataProvider.push(locales.getCaption('UploadedSounds', 'music'));
        dataProvider.push(locales.getCaption('RecordedSounds', 'music'));

        return dataProvider;
    },
    getSelectorDataProvider() {
        const clipartModel = this.props.soundClipartModel;

        if (!clipartModel)
            return [];

        var dataProvider = [];

        if (clipartModel && clipartModel.items[1]) { //Sound Effects
            const subcategoryItems = clipartModel.items[1].items;

            for (let i = 0; i < subcategoryItems.length; i++) {
                dataProvider.push(subcategoryItems[i].title);
            }
        }

        return dataProvider;
    },
    onUpload(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        window.parent.postMessage('openUploader', '*');
    },
    onMouseIn () {
        var button = document.getElementById('uploadButton');
        hoverManager.show(button, 'uploadButton');
    },
    onMouseOut () {
        hoverManager.hide();
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.mediaFilesDataProvider != newProps.mediaFilesDataProvider || this.props.windowHeight != newProps.windowHeight || this.props.accordionWidth != newProps.accordionWidth || this.props.slideAudioIndex != newProps.slideAudioIndex || this.props.soundEffectsCategoryIsExpanded != newProps.soundEffectsCategoryIsExpanded || this.props.soundEffectsCategoryIndex != newProps.soundEffectsCategoryIndex)
            return true;
        else
            return false;
    },
    render() {
        const menuStyle = {
            position: 'absolute',
            top: this.props.top,
            right: 0,
            width: this.props.accordionWidth,
            height: this.props.height,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white'
        };

        const selectorTopPosition = properties.BROWSER_BUTTON_HEIGHT;
        var height = this.props.windowHeight - properties.CLIPART_BUTTON_HEIGHT - 2 * properties.BROWSER_BUTTON_HEIGHT - 2 * properties.AUDIO_EDITOR_BUTTON_GAP - properties.CLIPART_BUTTON_HEIGHT;

        var uploadButton;
        var showUploadButton = !platformDetection.isIOSApp() && this.props.slideAudioIndex == 1 && (!this.props.soundEffectsCategoryIndex || this.props.soundEffectsCategoryIndex == 0);

        if (showUploadButton) {
            if (platformDetection.isIOS()) {
                var uploadIconStyle = {
                    position: 'absolute',
                    top: 85,
                    left: properties.BROWSER_WIDTH/2 - 42/2,
                    color: '#2DE102'
                };

                uploadButton = <i id='uploadButton' style={uploadIconStyle} className="fa fa-plus-circle fa-3x" onMouseDown={this.onUpload} onTouchStart={this.onUpload} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}/>;
            } else {
                var uploadButtonStyle = {
                    position: 'absolute',
                    top: 85,
                    left: properties.BROWSER_WIDTH/2 - 42/2,
                    margin: 0,
                    padding: 0,
                    boxSizing: 'initial',
                    fontSize: 'initial',
                    borderStyle: 'none',
                    width: 41,
                    height: 48,
                    background: 'none'
                };

                var uploadIconPlusStyle = {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    color: '#2DE102'
                };

                uploadButton =
                    <button id='uploadButton' aria-label={locales.getCaption('UploadHover', 'myFiles')} style={uploadButtonStyle} onClick={this.onUpload} onTouchStart={this.onUpload} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                        <i style={uploadIconPlusStyle} className="fa fa-plus-circle fa-3x"/>
                    </button>;
            }
        }

        var dataProvider = this.props.slideAudioIndex == 1 ? this.getMySoundsCategories() : this.getSelectorDataProvider();

        return (
            <div style={menuStyle}>
                <Button accordionWidth={this.props.accordionWidth} type={'soundEffects'} index={0} category={this.props.slideAudioIndex} dispatch={this.props.dispatch}/>
                <Button accordionWidth={this.props.accordionWidth} type={'soundEffects'} index={1} category={this.props.slideAudioIndex} dispatch={this.props.dispatch}/>
                <AudioCategorySelectorNew accordionWidth={this.props.accordionWidth} isAdvancedMenu={true} type={'soundEffects'} visible={true} isExpanded={this.props.soundEffectsCategoryIsExpanded} selectedIndex={this.getSelectedIndex()} dataProvider={dataProvider} dispatch={this.props.dispatch} top={selectorTopPosition}/>
                {uploadButton}
                <MediaSoundsList accordionWidth={this.props.accordionWidth} dataProvider={this.getDataProvider()} showUploadButton={showUploadButton} isAudioTab={true} height={height} categoriesVisible={true} dispatch={this.props.dispatch}/>
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    const mediaFilesDataProvider = state.accordion.mediaFilesDataProvider;
    var slideAudioIndex = state.music.slideAudioIndex;
    var soundClipartModel = state.music.soundClipartModel;
    const soundEffectsCategoryIsExpanded = state.menu.soundEffectsCategoryIsExpanded;
    var soundEffectsCategoryIndex = state.music.soundEffectsCategoryIndex;

    if (!slideAudioIndex)
        slideAudioIndex = 0;

    if (!soundEffectsCategoryIndex || isNaN(soundEffectsCategoryIndex))
        soundEffectsCategoryIndex = 0;

    return {
        mediaFilesDataProvider,
        slideAudioIndex,
        soundClipartModel,
        soundEffectsCategoryIsExpanded,
        soundEffectsCategoryIndex
    };
}

export const SlideSoundsBrowser = connect(mapStateToProps)(SlideSoundsBrowserContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/SlideSoundsBrowser.js
 **/